var _circle, _g, _ellipse, _g2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceBlockIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 46,
    viewBox: "0 0 192 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_95_9801",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 43,
    height: 44
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.1902,
    cy: 23.0001,
    r: 21.1902,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_95_9801)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.3804,
    height: 42.3804,
    transform: "translate(0 1.80994)",
    fill: "#FC3F1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1765 35.7355H28.6036V10.3073H22.1642C15.6882 10.3073 12.2856 13.6367 12.2856 18.5394C12.2856 22.4543 14.1515 24.7593 17.481 27.1374L11.7002 35.7355H16.4931L22.9325 26.113L20.7007 24.6129C17.9932 22.7835 16.6761 21.3566 16.6761 18.2833C16.6761 15.5758 18.5786 13.7465 22.2008 13.7465H24.1765V35.7355Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_95_9801",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 45,
    y: 1,
    width: 44,
    height: 44
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.1023,
    cy: 23.0004,
    rx: 21.1902,
    ry: 21.1902,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_95_9801)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.3804,
    height: 42.3804,
    transform: "translate(45.9121 1.81018)",
    fill: "url(#paint0_linear_95_9801)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9121 38.516L56.0284 26.4412L53.551 35.897L61.2276 38.6781L72.6333 22.4193L70.1344 31.7169L76.3533 35.3155L88.2925 23.3664V13.5336L79.825 22.0167L81.7041 11.339L73.8758 8.48206L62.618 24.545L63.7387 17.2552L57.6048 13.7175L45.9121 27.66V38.516Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.331 36.38C113.181 36.38 115.119 35.354 116.297 34.556V30.87C114.777 31.972 113.105 32.808 110.673 32.808C106.493 32.808 104.517 29.426 104.517 22.814C104.517 16.012 106.417 12.782 110.901 12.782C112.991 12.782 114.929 13.694 116.297 14.568V10.882C115.081 10.008 113.105 9.21 110.673 9.21C103.643 9.21 99.8426 14.378 99.8426 22.814C99.8426 31.478 103.795 36.38 110.331 36.38ZM130.367 36H135.497L128.239 25.702L134.623 16.886H130.063L123.679 25.702V16.886H119.157V36H123.679V26.614L130.367 36ZM135.71 32.086V36C135.71 36 136.432 36.38 137.496 36.38C141.372 36.38 142.36 33.644 142.588 27.298L142.854 20.458H147.452V36H151.974V16.886H139.016L138.636 27.108C138.484 31.174 138.218 32.428 136.736 32.428C136.09 32.428 135.71 32.086 135.71 32.086ZM170.072 22.966C170.072 18.33 167.716 16.582 162.928 16.582C159.926 16.582 157.57 17.532 156.202 18.33V22.092C157.418 21.18 160.078 20.192 162.396 20.192C164.562 20.192 165.55 20.952 165.55 23.004V24.068H164.828C157.912 24.068 154.834 26.348 154.834 30.224C154.834 34.1 157.19 36.266 160.686 36.266C163.346 36.266 164.486 35.392 165.36 34.48H165.55C165.588 34.974 165.74 35.62 165.892 36H170.3C170.148 34.442 170.072 32.884 170.072 31.326V22.966ZM165.55 31.44C164.98 32.276 163.916 32.96 162.32 32.96C160.42 32.96 159.47 31.82 159.47 30.11C159.47 27.868 161.028 27.07 164.904 27.07H165.55V31.44ZM190.504 32.428H188.49V16.886H175.304V18.52C175.304 23.194 175 29.236 173.404 32.428H171.998V40.37H176.178V36H186.324V40.37H190.504V32.428ZM183.968 32.428H177.584C178.838 29.54 179.18 24.334 179.18 21.028V20.458H183.968V32.428Z",
    fill: "#21201F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_95_9801",
    x1: 21.1902,
    y1: -10.0848,
    x2: 21.1902,
    y2: 46.4033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE55B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCC00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceBlockIcon);
export default __webpack_public_path__ + "static/media/service_block-icon.91d16bd13d949740881de66b21a922ea.svg";
export { ForwardRef as ReactComponent };